import Client from '../HttpClient';
import { systemSourceUrl } from '../../helpers/SystemSourceHelper';

const baseUrl = '/api/vs/doordash/ssio';

// 获取门店绑定状态
const branchStatus = (
	systemSource,
	merchantId,
	branchId,
	companyCode = 'DoorDash'
) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/manage-cooperation/${merchantId}/onlineCooperationCompanyRelations`
		),
		{ branchId, companyCode }
	);
};

// 获取认证链接
const getAuthorizeUrl = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/${branchId}/authorize-url`
		)
	);
};

// 用 code 拉取 DoorDash 店铺候选列表
const getStores = (systemSource, merchantId, payload) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/stores`),
		payload
	);
};

// 选择 DoorDash 店铺并开始绑定
const bind = (systemSource, merchantId, payload = {}) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/bind`),
		payload
	);
};

// 解绑
const unbind = (systemSource, merchantId, payload = {}) => {
	return Client.post(
		systemSourceUrl(systemSource, `${baseUrl}/${merchantId}/pos_data/remove`),
		payload
	);
};

// 查询 / 刷新当前门店绑定状态
const getStatus = (systemSource, merchantId, branchId, payload = {}) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/${branchId}/status`
		),
		payload
	);
};

// 重试菜单导入
const retryMenus = (systemSource, merchantId, branchId) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/${branchId}/menus/retry`
		)
	);
};

// 激活集成
const activate = (systemSource, merchantId, branchId) => {
	return Client.post(
		systemSourceUrl(
			systemSource,
			`${baseUrl}/${merchantId}/${branchId}/activate`
		)
	);
};

// 获取店铺信息
const getStoreStatus = (systemSource, merchantId, branchId) => {
	return Client.get(
		systemSourceUrl(
			systemSource,
			`/api/vs/doordash/store/${merchantId}/${branchId}/status`
		)
	);
};

// 修改店铺状态
const updateStoreStatus = (systemSource, merchantId, branchId, payload) => {
	return Client.put(
		systemSourceUrl(
			systemSource,
			`/api/vs/doordash/store/${merchantId}/${branchId}/status`
		),
		payload
	);
};

export default {
	branchStatus,
	getAuthorizeUrl,
	getStores,
	bind,
	unbind,
	getStatus,
	retryMenus,
	activate,
	getStoreStatus,
	updateStoreStatus,
};
